module.exports = __webpack_public_path__ + "img/feature-workout.b5a591a3.jpg";